import type { ISkeletonLoaderProps, TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const journalNewsPerPage = 13

const commonNewsSkeleton: ISkeletonLoaderProps = {
  className: 'journal-news-announce journal-news-announce-link',
  height: null,
  styleName: 'white',
  skeletons: [
    {
      className: 'journal-news-announce__title row_column',
      styleName: 'white',
      height: null,
      skeletons: [{ className: 'h3' }, { className: 'text_large space-holder-top16 journal-news-announce__text' }],
    },
  ],
}

export const newsSkeletons: TSkeletons = [
  {
    ...commonNewsSkeleton,
    skeletons: [...(commonNewsSkeleton.skeletons as TSkeletons), { className: 'journal-news-announce__image', width: null, height: null }],
  },
  commonNewsSkeleton,
  commonNewsSkeleton,
]
